import Vue from 'vue';
import Errors from '../classes/Errors'; // eslint-disable-line

Vue.component('enquiries-form-component', {
    props: {
        redirect: String
    },
    
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
        };
    },

    methods: {
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios.post(form.action, new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);

                        Vue.nextTick(() => {
                            this.errors.scrollToFirstError(this.$el.querySelector('.form__input--has-error'));
                        });
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    Vue.nextTick(() => {
                        window.location.href = this.redirect;
                    });
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error);
                });
        },
    },
});